import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { catchError, switchMap, throwError } from "rxjs";
import { AuthApiService } from "../services/auth-api.service";
import { getAccessToken, getRefreshToken } from "../../state/auth/auth.selectors";
import { Router } from "@angular/router";
import { AuthActions } from "../../state/auth/auth.actions";

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  const authApiService = inject(AuthApiService);
  const router = inject(Router);


  // Using selectSignal avoids the deprecated signature of store.select
  // and gives us the current snapshot of the tokens immediately.
  const accessToken = store.selectSignal(getAccessToken)();
  const refreshToken = store.selectSignal(getRefreshToken)();

  let authReq = req;

  // 1. Add the Bearer token if it exists in the Store
  if (accessToken) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // 2. Handle 401 Unauthorized and ensure we have a refresh token
      if (error.status === 401 && refreshToken && accessToken) {
        return authApiService.refreshToken(accessToken, refreshToken).pipe(
          switchMap((refreshResponse) => {
            store.dispatch(AuthActions.refreshTokenSuccess({response: refreshResponse}));
            // 3. Retry the failed request with the new token
            const retryReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${refreshResponse.token}`
              },
            });
            return next(retryReq);
          }),
           catchError((refreshError) => {
            router.navigate(['/login']);
            return throwError(() => {
              return refreshError
            });
          })
        );
      }
      return throwError(() => error);
    })
  );
};
